import Box from "@mui/material/Box";

export function ItemIcon({ src }) {
	return (
		<Box
			sx={[
				{
					overflow: "hidden",
					borderRadius: 1.5,
					alignItems: "center",
					display: "inline-flex",
					flex: "0 0 auto",
					justifyContent: "center",
					width: "100%",
					height: "100%",
					backgroundImage: `url("${src}")`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					minHeight: "242px",
				},
			]}
		/>
	);
}
